import $ from 'jquery';

$('button.grading__question-summary-row').on('click', event => {
  const group = event.currentTarget.closest('.grading__question');

  $('.grading__icon-group', group).toggleClass('grading__icon-group--collapsed');
  $('.grading__details-row', group).slideToggle(200);
});
